import {useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'

import {Modal} from 'bootstrap'
import {ModalProvider} from './ModalContext'

const OwnModal = ({
  open,
  setOpen,
  children,
  focus = true,
  className = '',
  backdropClassName = '',
}) => {
  const modalRef = useRef()
  const modalRoot = typeof document !== 'undefined' ? document.body : null

  const showModal = () => {
    const modalEle = modalRef.current
    const bsModal = new Modal(modalEle, {
      backdrop: 'static',
      keyboard: false,
      focus,
    })
    bsModal.show()

    if (backdropClassName) {
      const backdrops = document.querySelectorAll('.modal-backdrop')
      backdrops[backdrops.length - 1]?.classList.add(backdropClassName)
    }
  }

  const hideModal = (finalClose) => {
    if (typeof setOpen === 'function') {
      setOpen(false)
    }

    const modalEle = modalRef.current
    const bsModal = Modal.getInstance(modalEle)

    if (bsModal == null) {
      if (finalClose) {
        const backdrop = document.querySelector('.modal-backdrop')

        if (backdrop == null) {
          return
        }

        backdrop.parentElement.removeChild(backdrop)
      }

      return
    }

    bsModal.hide()
  }

  useEffect(() => {
    if (open) {
      showModal()
    } else {
      hideModal()
    }
  }, [open])

  useEffect(() => {
    return () => {
      hideModal(true)
    }
  }, [])

  if (modalRoot == null) {
    return null
  }

  return createPortal(
    <div className={`modal fade ${className}`.trim()} ref={modalRef} tabIndex='-1'>
      <ModalProvider hideModal={hideModal}>
        {children}
      </ModalProvider>
    </div>,
    modalRoot
  )
}

export default OwnModal
